import React, { useContext, useEffect, useState } from "react";
import DataTable from "../DataTable/DataTable";
import "./managejd.css";
import "../jobdescupload/jdupload.css";
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AddCircle from '@mui/icons-material/AddCircle';
import Cancel from '@mui/icons-material/Cancel';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Switch from '@mui/material/Switch';
import { useLocation, useNavigate } from "react-router-dom";
import { UserTypeContext } from "../../AppRoute";
import getAllJobDescription from "../../apis/candidatescreening/getjd";
import getAllPrimarySkillData from "../../apis/getAllPrimarySkillData";
import Autocomplete from '@mui/material/Autocomplete';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DateTime } from "luxon";
import NotificationManager from "react-notifications/lib/NotificationManager";
import jobDescription from "../../apis/candidatescreening/jobdescription";
import jobDescriptionVet from "../../apis/vettest/getvetjd";

const MAX_SKILLS = 5;
const MAX_TOTAL_WEIGHTAGE = 100;
const SKILL_DIFFICULTY_OPTIONS = ['Basic', 'Intermediate', 'Advanced'];

const getTotalWeightage = (skillsList, excludeIndex = -1) =>
  skillsList.reduce((sum, skill, i) => {
    if (i === excludeIndex || skill.weightage === '' || skill.weightage === undefined) {
      return sum;
    }
    return sum + Number(skill.weightage);
  }, 0);

const mapRowSkillsToForm = (skills) => {
  if (!Array.isArray(skills) || skills.length === 0) {
    return [{ skill: '', weightage: '', difficultyLevel: '', isPrimary: true }];
  }
  return skills.map((s) => ({
    skill: s.skill || '',
    weightage: s.weightage !== undefined && s.weightage !== null ? s.weightage : '',
    difficultyLevel: s.difficultyLevel || '',
    isPrimary: Boolean(s.isPrimary),
  }));
};

const normalizeSkillsForPayload = (skillsList) =>
  skillsList.map((skill) => ({
    skill: skill.skill.trim(),
    weightage: Number(skill.weightage),
    difficultyLevel: skill.difficultyLevel,
    isPrimary: Boolean(skill.isPrimary),
  }));

const ManageJd = () => {
  const jsonConfig = require("../../Config.json");
  const history = useNavigate();
  const location = useLocation();
  const { userType, userRecords } = useContext(UserTypeContext);
  const userRecruitmentpartnerId =
    userType === "Admin"
      ? location?.state?.recruitmentPartnerId
      : userRecords?.recruitmentpartnerId;
  const idContextTest =
    userType === "Admin" ? location?.state?.id : userRecords?.id;
  const userRole =
    userType === "Admin"
      ? location?.state?.userRole
      : userRecords?.role?.roleName;
  const userRecordData =
    userType === "Admin" ? location?.state?.userRecords : userRecords;

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [toggleAiScreenData, setToggleAiScreenData] = useState();
  const [editFormData, setEditFormData] = useState({
    jobTitle: '',
    jobDesc: '',
    link: '',
    difficultyLevel: '',
    assessmentDurationInSeconds: '',
    type: '',
    duration: '',
    isActive: true,
    expiryAt: null
  });
  const [skills, setSkills] = useState([
    { skill: '', weightage: '', difficultyLevel: '', isPrimary: true }
  ]);
  const [skillOptions, setSkillOptions] = useState([]);
  const toggleAiScreen = location.pathname !== '/interview-management-vet';

  // state for server-side table
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [columnFilters, setColumnFilters] = useState([]);
  const [pendingFilters, setPendingFilters] = useState([]);

  const getPrimarySkill = (skills) => {
    if (!Array.isArray(skills)) return '';
    const primary = skills.find((s) => s.isPrimary);
    return primary?.skill || '';
  };

  const getAdditionalSkills = (skills) => {
    if (!Array.isArray(skills)) return '';
    return skills
      .filter((s) => !s.isPrimary)
      .map((s) => s.skill)
      .filter(Boolean)
      .join(', ');
  };

  const isActiveFilterFn = (row, columnId, filterValue) => {
    if (!filterValue) return true;
    const rowValue = row.getValue(columnId);
    const filterValLower = filterValue.toLowerCase();
    if (filterValLower === 'true') return rowValue === true;
    if (filterValLower === 'false') return rowValue === false;
    return true;
  };

  const fetchDataVet = async (page = currentPage, size = pageSize, colFilters = columnFilters) => {
    setIsLoading(true);
    const offset = (page - 1) * size;
    const filtersObj = {};
    if (Array.isArray(colFilters)) {
      colFilters.forEach((f) => {
        if (f?.id && f.value !== '') {
          const key = f.id === 'customer_name' ? 'customerName' : f.id;
          if (key === 'isActive') {
            filtersObj[key] = f.value === 'true' ? true : (f.value === 'false' ? false : f.value);
          } else if (key === 'createdAt' || key === 'updatedAt') {
            if (f.value) {
              filtersObj[key] = f.value;
            }
          } else {
            filtersObj[key] = f.value;
          }
        }
      });
    }
    const payload = {
      offset,
      limit: size,
      filters: filtersObj,
      recruitmentpartnerId: userRecruitmentpartnerId || "",
    };
    const data = await jobDescriptionVet(payload);
    setToggleAiScreenData(data?.data?.data || []);
    setTotalRecords(data?.data?.count || data?.data?.data?.length || 0);
    setIsLoading(false);
  }

  useEffect(() => {
    if (!toggleAiScreen) {
      fetchDataVet(currentPage, pageSize, columnFilters,);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toggleAiScreen]);

  const fetchPrimarySkills = async () => {
    try {
      const payload = {
        userRecruitmentpartnerId: userRecruitmentpartnerId,
        userId: idContextTest,
      };
      const response = await getAllPrimarySkillData(payload);
      const options = response.data.data.map((skill) => skill.name);
      setSkillOptions(options);
    } catch (error) {
      console.error('Error fetching primary skills:', error);
    }
  };

  const getIsActiveFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    const activityOptions = [
      { label: 'All', value: '' },
      { label: 'True', value: 'true' },
      { label: 'False', value: 'false' }
    ];
    let value = activityOptions.find(opt => opt.value === filterValue);
    if (!value) {
      value = { label: 'All', value: '' };
    }
    return value;
  };

  function dateFilterFn(row, columnId, filterValue) {
    if (!filterValue) return true;
    let rowValue;
    if (columnId === 'createdAt') {
      rowValue = row.original.created_at || row.original.createdAt;
    } else if (columnId === 'updatedAt') {
      rowValue = row.original.updated_at || row.original.updatedAt;
    } else {
      rowValue = row.original.expiresOn;
    }
    if (!rowValue) return false;
    try {
      const rowDate = DateTime.fromISO(rowValue).startOf('day');
      const filterDate = DateTime.fromISO(filterValue).startOf('day');
      if (!rowDate.isValid || !filterDate.isValid) return false;
      return rowDate.toMillis() === filterDate.toMillis();
    } catch (error) {
      console.warn('Date filtering error:', error);
      return false;
    }
  }

  const getDateFilterValue = (column) => {
    const filterValue = column.getFilterValue();
    if (!filterValue) return null;
    const dt = DateTime.fromISO(filterValue);
    return dt.isValid ? dt.toJSDate() : null;
  };

  const handleEditClick = (row) => {
    setSelectedRow(row);
    let expiryDate = null;
    if (row.expiryAt) {
      const parsedDate = DateTime.fromISO(row.expiryAt);
      if (parsedDate.isValid) {
        expiryDate = parsedDate.toJSDate();
      }
    }
    setEditFormData({
      jobTitle: row.jobTitle || '',
      jobDesc: row.jobDesc || '',
      link: row.link || '',
      difficultyLevel: row.difficultyLevel || '',
      assessmentDurationInSeconds: row.assessmentDurationInSeconds || '',
      type: row.type || '',
      duration: row.duration || '',
      isActive: row.isActive !== undefined ? row.isActive : true,
      expiryAt: expiryDate
    });
    setSkills(mapRowSkillsToForm(row.skills));
    if (toggleAiScreen) {
      fetchPrimarySkills();
    }
    setDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedRow(null);
    setEditFormData({
      jobTitle: '',
      jobDesc: '',
      link: '',
      isActive: true,
      expiryAt: null
    });
    setSkills([{ skill: '', weightage: '', difficultyLevel: '', isPrimary: true }]);
  };

  const handleFormChange = (field, value) => {
    setEditFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const addSkill = () => {
    if (skills.length >= MAX_SKILLS) {
      NotificationManager.warning(
        `Maximum ${MAX_SKILLS} skills allowed`,
        'Warning',
        5000
      );
      return;
    }
    setSkills([
      ...skills,
      { skill: '', weightage: '', difficultyLevel: '', isPrimary: false }
    ]);
  };

  const removeSkill = (index) => {
    if (skills.length > 1) {
      const updatedSkills = [...skills];
      const wasPrimary = updatedSkills[index].isPrimary;
      updatedSkills.splice(index, 1);
      if (wasPrimary && updatedSkills.length > 0) {
        updatedSkills[0].isPrimary = true;
      }
      setSkills(updatedSkills);
    }
  };

  const handleSkillChange = (value, index, field) => {
    const updatedSkills = [...skills];
    updatedSkills[index][field] = value;
    setSkills(updatedSkills);
  };

  const totalWeightage = getTotalWeightage(skills);

  const handleWeightageChange = (value, index) => {
    if (value === '') {
      handleSkillChange('', index, 'weightage');
      return;
    }

    const numVal = Number(value);
    if (Number.isNaN(numVal) || numVal < 0) return;

    const otherTotal = getTotalWeightage(skills, index);
    const maxAllowed = MAX_TOTAL_WEIGHTAGE - otherTotal;

    if (maxAllowed <= 0) {
      handleSkillChange(0, index, 'weightage');
      return;
    }

    handleSkillChange(Math.min(numVal, MAX_TOTAL_WEIGHTAGE, maxAllowed), index, 'weightage');
  };

  const handlePrimaryToggle = (index, checked) => {
    if (checked) {
      setSkills(skills.map((skill, i) => ({
        ...skill,
        isPrimary: i === index,
      })));
    } else {
      setSkills(skills.map((skill, i) => ({
        ...skill,
        isPrimary: i === index ? false : skill.isPrimary,
      })));
    }
  };

  const validateSkills = () => {
    for (let i = 0; i < skills.length; i++) {
      const skill = skills[i];
      if (!skill.skill.trim()) {
        NotificationManager.error(`Please enter skill name for row ${i + 1}`, 'Error', 5000);
        return false;
      }
      if (!skill.difficultyLevel) {
        NotificationManager.error(`Please select proficiency level for row ${i + 1}`, 'Error', 5000);
        return false;
      }
      if (!skill.weightage && skill.weightage !== 0) {
        NotificationManager.error(`Please enter weightage for row ${i + 1}`, 'Error', 5000);
        return false;
      }
      if (Number(skill.weightage) < 0) {
        NotificationManager.error(`Please enter valid weightage for row ${i + 1}`, 'Error', 5000);
        return false;
      }
    }

    const primaryCount = skills.filter((skill) => skill.isPrimary).length;
    if (primaryCount !== 1) {
      NotificationManager.error('Please mark exactly one skill as primary', 'Error', 5000);
      return false;
    }

    const totalWeightageOnSubmit = getTotalWeightage(skills);
    if (totalWeightageOnSubmit > MAX_TOTAL_WEIGHTAGE) {
      NotificationManager.error(
        `Total weightage across all skills cannot exceed ${MAX_TOTAL_WEIGHTAGE}`,
        'Error',
        5000
      );
      return false;
    }

    return true;
  };

  const handleSaveChanges = async () => {
    try {
      const newExpiryDate = editFormData.expiryAt ? editFormData.expiryAt.getTime() : null;
      if (newExpiryDate === null) {

        NotificationManager.error("Please select an expiry date", Error, 10000);
        return;
      }
      const payload = {};
      if (selectedRow._id !== undefined && selectedRow._id) {
        payload.id = selectedRow._id;
      }
      if (editFormData.jobTitle !== selectedRow.jobTitle) {
        payload.jobTitle = editFormData.jobTitle;
      }
      if (editFormData.jobDesc !== selectedRow.jobDesc) {
        payload.jobDesc = editFormData.jobDesc;
      }
      if (editFormData.link !== selectedRow.link) {
        payload.link = editFormData.link;
      }
      const formattedSkills = normalizeSkillsForPayload(skills);
      const originalSkills = normalizeSkillsForPayload(
        mapRowSkillsToForm(selectedRow.skills)
      );
      const skillsChanged = JSON.stringify(formattedSkills) !== JSON.stringify(originalSkills);
      if (skillsChanged) {
        if (!validateSkills()) {
          return;
        }
        payload.skills = formattedSkills;
      }
      if (editFormData.difficultyLevel !== selectedRow.difficultyLevel) {
        payload.difficultyLevel = editFormData.difficultyLevel;
      }
      if (editFormData.assessmentDurationInSeconds !== selectedRow.assessmentDurationInSeconds) {
        payload.assessmentDurationInSeconds = editFormData.assessmentDurationInSeconds;
      }
      if (editFormData.isActive !== selectedRow.isActive) {
        payload.isActive = editFormData.isActive;
      }
      const originalExpiryDate = selectedRow.expiryAt ? new Date(selectedRow.expiryAt).getTime() : null;
      if (originalExpiryDate !== newExpiryDate) {
        if (editFormData.expiryAt) {
          const year = editFormData.expiryAt.getFullYear();
          const month = String(editFormData.expiryAt.getMonth() + 1).padStart(2, '0');
          const day = String(editFormData.expiryAt.getDate()).padStart(2, '0');
          payload.expiryAt = `${year}-${month}-${day}`;
        } else {
          payload.expiryAt = null;
        }
      }
      if (Object.keys(payload).length === 0) {
        handleCloseDrawer();
        return;
      }
      setIsSaving(true);
      const response = await jobDescription(payload, true);
      if (response.status === 200) {
        await fetchData(currentPage, pageSize, columnFilters,);
        handleCloseDrawer();
      }
    } catch (error) {
      console.error('Failed to update job description:', error);
    } finally {
      setIsSaving(false);
    }
  };


  const JobDescCell = ({ text }) => {
    const [expanded, setExpanded] = useState(false);
    const limit = 160;
    if (!text) return null;
    const shouldTruncate = text.length > limit;
    const displayText = expanded || !shouldTruncate ? text : text.slice(0, limit) + "...";
    return (
      <div className="job-desc-cell">
        <div className="job-desc-text">{displayText}</div>
        {shouldTruncate && (
          <button
            type="button"
            className="show-more-btn"
            onClick={() => setExpanded((s) => !s)}
            aria-expanded={expanded}
          >
            {expanded ? "Show less" : "Show more"}
          </button>
        )}
      </div>
    );
  };

  const columns = toggleAiScreen ? [
    {
      accessorKey: "jobTitle",
      header: "Job Title",
      size: 200,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: "includesString",
    },
    {
      accessorKey: "jobDesc",
      header: "Job Description",
      size: 500,
      enableSorting: false,
      enableColumnFilter: true,
      filterFn: "includesString",
      cell: ({ getValue }) => <JobDescCell text={getValue() || ""} />,
    },
    {
      accessorKey: "link",
      header: "Link",
      size: 250,
      enableSorting: false,
      enableColumnFilter: false,
      filterFn: "includesString",
      cell: ({ getValue }) => {
        const originalLink = getValue();
        const link = originalLink ? `${originalLink}?int=ai` : '';
        const handleCopyLink = () => {
          if (link) {
            navigator.clipboard.writeText(link).then(() => {

              NotificationManager.success('Link Copied', 'The link has been copied to clipboard.');
            }).catch(err => {
              console.error('Failed to copy link:', err);
            });
          }
        };
        return link ? (
          <span
            onClick={handleCopyLink}
            className="jd-link"
            style={{ cursor: 'pointer', color: '#1976d2', textDecoration: 'underline' }}
            title="Click to copy link"
          >
            {link}
          </span>
        ) : '';
      },
    },
    {
      accessorKey: "isActive",
      header: "Is Active",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: isActiveFilterFn,
      cell: ({ getValue }) => (getValue() ? "True" : "False"),
      Filter: ({ column }) => (
        <Autocomplete
          disableClearable
          className='isActiveFilter-autocomplete'
          options={[
            { label: 'All', value: '' },
            { label: 'True', value: 'true' },
            { label: 'False', value: 'false' }
          ]}
          value={getIsActiveFilterValue(column)}
          onChange={(event, newValue) => {
            column.setFilterValue(newValue ? newValue.value : '');
          }}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
            />
          )}
          sx={{ width: '100%' }}
        />
      )
    },
    {
      accessorKey: "createdBy",
      header: "Created By",
      size: 140,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: "includesString",
    },
    {
      accessorKey: "primarySkills",
      header: "Primary Skill",
      size: 140,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: "includesString",
      cell: ({ row }) => row.original.primarySkills || getPrimarySkill(row.original.skills) || 'Not available',
    },
    {
      accessorKey: "additionalSkills",
      header: "Additional Skills",
      size: 180,
      enableSorting: false,
      enableColumnFilter: true,
      filterFn: "includesString",
      cell: ({ row }) => getAdditionalSkills(row.original.skills) || 'Not available',
    },
    {
      accessorKey: "difficultyLevel",
      header: "Difficulty Level",
      size: 140,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: "equals",
      Filter: ({ column }) => {
        const options = [
          { label: 'All', value: '' },
          { label: 'Beginner', value: 'Beginner' },
          { label: 'Intermediate', value: 'Intermediate' },
          { label: 'Advanced', value: 'Advanced' }
        ];

        const filterValue = column.getFilterValue() || '';
        const currentOption = options.find((opt) => opt.value === filterValue) || options[0];

        return (
          <Autocomplete
            disableClearable
            className="difficultyLevelFilter-autocomplete"
            options={options}
            value={currentOption}
            onChange={(event, newValue) => {
              column.setFilterValue(newValue ? newValue.value : '');
            }}
            getOptionLabel={(option) => option.label}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                placeholder="Select level"
              />
            )}
            sx={{ width: '100%' }}
          />
        );
      },
    },
    {
      accessorKey: "assessmentDurationInSeconds",
      header: "Assessment Duration (seconds)",
      size: 140,
      enableSorting: false,
      enableColumnFilter: false,
      filterFn: "includesString",
    },
    {
      accessorKey: "type",
      header: "Interview type",
      size: 140,
      enableSorting: false,
      enableColumnFilter: false,
      filterFn: "includesString",
    },
    {
      accessorKey: "createdAt",
      header: "Created At",
      filterFn: dateFilterFn,
      Filter: ({ column }) => (
        <div className="date-picker-filter-container">
          <DatePicker
            selected={getDateFilterValue(column)}
            onChange={(date) => {
              if (date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                column.setFilterValue(`${year}-${month}-${day}`);
              } else {
                column.setFilterValue('');
              }
            }}
            dateFormat="MM/dd/yyyy"
            placeholderText="Select date"
            isClearable
            showIcon={true}
            className="date-picker-table-filter"
          />
        </div>
      ),
      cell: ({ row }) => (
        (() => {
          const raw = row.original.created_at || row.original.createdAt;
          if (!raw) return "";
          const iso = DateTime.fromISO(raw);
          if (iso.isValid) return iso.toFormat("MM/dd/yyyy");
          const jsDate = new Date(raw);
          if (!isNaN(jsDate.getTime())) return DateTime.fromJSDate(jsDate).toFormat("MM/dd/yyyy");
          return String(raw);
        })()
      ),
      size: 200,
      enableSorting: true,
      enableColumnFilter: true,
    },
    {
      accessorKey: "updatedAt",
      header: "Updated At",
      filterFn: dateFilterFn,
      Filter: ({ column }) => (
        <div className="date-picker-filter-container">
          <DatePicker
            selected={getDateFilterValue(column)}
            onChange={(date) => {
              if (date) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                column.setFilterValue(`${year}-${month}-${day}`);
              } else {
                column.setFilterValue('');
              }
            }}
            dateFormat="MM/dd/yyyy"
            placeholderText="Select date"
            isClearable
            showIcon={true}
            className="date-picker-table-filter"
          />
        </div>
      ),
      cell: ({ row }) => (
        (() => {
          const raw = row.original.updated_at || row.original.updatedAt;
          if (!raw) return "";
          const iso = DateTime.fromISO(raw);
          if (iso.isValid) return iso.toFormat("MM/dd/yyyy");
          const jsDate = new Date(raw);
          if (!isNaN(jsDate.getTime())) return DateTime.fromJSDate(jsDate).toFormat("MM/dd/yyyy");
          return String(raw);
        })()
      ),
      size: 140,
      enableSorting: true,
      enableColumnFilter: true,
    },
    {
      accessorKey: "expiryAt",
      header: "Expiry Date",
      cell: ({ row }) => {
        const raw = row.original.expiryAt;
        if (!raw) return "N/A";
        const iso = DateTime.fromISO(raw);
        if (iso.isValid) return iso.toFormat("MM/dd/yyyy");
        const jsDate = new Date(raw);
        if (!isNaN(jsDate.getTime())) return DateTime.fromJSDate(jsDate).toFormat("MM/dd/yyyy");
        return String(raw);
      },
      size: 140,
      enableSorting: true,
      enableColumnFilter: false,
    },
    {
      accessorKey: "candidateCount",
      header: "No. of Candidates",
      size: 140,
      enableSorting: false,
      enableColumnFilter: false,
      cell: ({ row }) => {
        const handleCandidatesClick = () => {
          history('/jdcandidates', {
            state: {
              jdId: row.original._id || row.original.id,
              jobDesc: row.original.jobDesc,
              userType: userType,
              recruitmentPartnerId: userRecruitmentpartnerId,
              id: idContextTest,
              userRecords: userRecordData,
              userRole: userRole,
              toggleAiScreen: toggleAiScreen,
            }
          });
        };
        return (
          <Button
            onClick={row.original.candidateCount === 0 ? null : handleCandidatesClick}
            className="candidates-count-link"
            variant="text"
            color="primary"
          >
            {row.original.candidateCount}
          </Button>
        );
      },
    },
    {
      accessorKey: "actions",
      header: "Actions",
      size: 140,
      enableSorting: false,
      enableColumnFilter: false,
      cell: ({ row }) => (
        <div style={{ display: 'flex', gap: 8 }}>
          <Button
            color="primary"
            onClick={() => handleEditClick(row.original)}
            size="small"
            variant="contained"
          >
            Edit
          </Button>
        </div>
      ),
    }
  ] : [
    {
      accessorKey: "title",
      header: "Verbal English Test Title",
      size: 200,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: "includesString",
    },
    {
      accessorKey: "type",
      header: "Type",
      size: 120,
      enableSorting: false,
      enableColumnFilter: false,
      filterFn: "includesString",
    },
    {
      accessorKey: "description",
      header: "Description",
      size: 300,
      enableSorting: false,
      enableColumnFilter: false,
      filterFn: "includesString",
    },
    {
      id: "id",
      header: "Link",
      size: 250,
      enableSorting: false,
      enableColumnFilter: false,
      cell: ({ row }) => {
        const link = `${jsonConfig.CTApplicationUrl}interview/${row.original.id}?int=vet`;
        const handleCopyLink = () => {
          navigator.clipboard.writeText(link);
          NotificationManager.success(
            "Link Copied",
            "The link has been copied to clipboard."
          );
        };

        return (
          <span
            onClick={handleCopyLink}
            className="jd-link"
            style={{
              cursor: "pointer",
              color: "#1976d2",
              textDecoration: "underline",
            }}
          >
            {link}
          </span>
        );
      },
    },
    {
      accessorKey: "customer.name",
      header: "Customer",
      size: 180,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: "includesString",
    },
    {
      accessorKey: "isActive",
      header: "Is Active",
      size: 150,
      enableSorting: true,
      enableColumnFilter: true,
      filterFn: isActiveFilterFn,
      cell: ({ getValue }) => (getValue() ? "True" : "False"),
      Filter: ({ column }) => (
        <Autocomplete
          disableClearable
          className="isActiveFilter-autocomplete"
          options={[
            { label: "All", value: "" },
            { label: "True", value: "true" },
            { label: "False", value: "false" },
          ]}
          value={getIsActiveFilterValue(column)}
          onChange={(event, newValue) => {
            column.setFilterValue(newValue ? newValue.value : "");
          }}
          getOptionLabel={(option) => option.label}
          renderInput={(params) => (
            <TextField {...params} size="small" />
          )}
          sx={{ width: "100%" }}
        />
      ),
    },
    {
      accessorKey: "candidateCount",
      header: "No. of Candidates",
      size: 140,
      enableSorting: false,
      enableColumnFilter: false,
      cell: ({ row }) => {
        const handleCandidatesClick = () => {
          history('/jdcandidates', {
            state: {
              jdId: row.original._id || row.original.id,
              userType: userType,
              recruitmentPartnerId: userRecruitmentpartnerId,
              id: idContextTest,
              userRecords: userRecordData,
              userRole: userRole,
              toggleAiScreen: toggleAiScreen,
              vetTestId: row.original.vetTests[0].id
            }

          });
        }

          ;
        return (
          <Button
            onClick={row.original.candidateCount === 0 ? null : handleCandidatesClick}
            className="candidates-count-link"
            variant="text"
            color="primary"
          >
            {row.original.candidateCount}
          </Button>
        );
      },
    },
  ]
  const fetchData = async (page = currentPage, size = pageSize, colFilters = columnFilters,) => {
    setIsLoading(true);
    try {
      const offset = (page - 1) * size;
      const filtersObj = {};
      if (Array.isArray(colFilters)) {
        colFilters.forEach((f) => {
          if (f?.id && f.value !== '') {
            if (f.id === 'isActive') {
              filtersObj[f.id] = f.value === 'true' ? true : (f.value === 'false' ? false : f.value);
            } else if (f.id === 'createdAt' || f.id === 'updatedAt') {
              if (f.value) {
                filtersObj[f.id] = f.value;
              }
            } else {
              filtersObj[f.id] = f.value;
            }
          }
        });
      }
      const resp = await getAllJobDescription({
        offset,
        limit: size,
        filters: filtersObj,
        recruitmentpartnerId: userRecruitmentpartnerId || "",
      });
      const rawList = resp.jobDescriptions || [];
      const formatDate = (iso) => {
        if (!iso) return "";
        const d = DateTime.fromISO(iso);
        if (!d.isValid) return iso;
        return d.toFormat("dd-MM-yyyy");
      };
      const jobDescriptions = rawList.map(item => {
        const createdByName =
          item.creatorData?.displayName ||
          (item.creatorData?.firstName || item.creatorData?.lastName
            ? `${item.creatorData?.firstName || ""} ${item.creatorData?.lastName || ""}`.trim()
            : item.createdBy);
        return {
          ...item,
          createdBy: createdByName,
          createdAt: formatDate(item.created_at || item.createdAt),
          updatedAt: formatDate(item.updated_at || item.updatedAt),
          primarySkills: getPrimarySkill(item.skills) || item.primarySkills || '',
          additionalSkills: getAdditionalSkills(item.skills),
        };
      });
      const totalCount = resp.totalCount || 0;
      setData(jobDescriptions);
      if (toggleAiScreen)
        setTotalRecords(totalCount);


    } catch (err) {
      console.error("Failed to fetch job descriptions:", err);
      setData([]);
      setTotalRecords(0);
    } finally {
      setIsLoading(false);
    }
  };

  // Debounced effect for filters
  useEffect(() => {

    if (!pendingFilters) return;
    const timerId = setTimeout(() => {
      if (toggleAiScreen)
        fetchData(1, pageSize, pendingFilters,);
      else
        fetchDataVet(1, pageSize, pendingFilters,);

      setCurrentPage(1);
    }, 600);
    return () => clearTimeout(timerId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingFilters, pageSize]);

  const handlePageChange = (pageNumber, newPageSize) => {
    const size = newPageSize || pageSize;
    setCurrentPage(pageNumber);
    setPageSize(size);
    if (!toggleAiScreen)
      fetchDataVet(pageNumber, size, columnFilters,);
    else
      fetchData(pageNumber, size, columnFilters,);
  };

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    setCurrentPage(1);

    if (!toggleAiScreen)
      fetchDataVet(1, newSize, columnFilters,);
    else
      fetchData(1, newSize, columnFilters,);
  };

  const handleFilterChange = (newFiltersArray) => {
    const filters = newFiltersArray || [];
    setColumnFilters(filters);
    setPendingFilters(filters);
  };

  return (
    <div>
      <div className="manage-jd-table">
        <DataTable
          data={!toggleAiScreen ? toggleAiScreenData : data}
          columns={columns}
          isLoading={isLoading}
          isServerSide={true}
          totalRecords={totalRecords}
          currentPage={currentPage}
          pageSize={pageSize}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          onFilterChange={handleFilterChange}
          initialPageSize={10}
          pageSizeOptions={[10, 20, 50]}
          className="manage-jd-datatable"
          noDataText="No job descriptions found."
        />
      </div>
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={handleCloseDrawer}
      >
        <div className="drawer-container">
          {isSaving && (
            <div className="drawer-loading-overlay">
              <CircularProgress />
            </div>
          )}
          <div className="drawer-header">
            <h2 className="drawer-title">Edit Job Description</h2>
            <IconButton onClick={handleCloseDrawer} disabled={isSaving}>
              <CloseIcon />
            </IconButton>
          </div>
          {selectedRow && (
            <div className="drawer-content">
              <div className="drawer-field">
                <label className="drawer-label">Job Title</label>
                <TextField
                  fullWidth
                  value={editFormData.jobTitle}
                  onChange={(e) => handleFormChange('jobTitle', e.target.value)}
                  variant="outlined"
                  disabled={isSaving}
                />
              </div>
              <div className="drawer-field">
                <label className="drawer-label">Job Description</label>
                <TextField
                  multiline
                  rows={8}
                  fullWidth
                  value={editFormData.jobDesc}
                  onChange={(e) => handleFormChange('jobDesc', e.target.value)}
                  variant="outlined"
                  disabled={isSaving}
                />
              </div>
              <div className="drawer-field">
                <label className="drawer-label">Link</label>
                <TextField
                  fullWidth
                  value={editFormData.link}
                  onChange={(e) => handleFormChange('link', e.target.value)}
                  variant="outlined"
                  disabled
                />
              </div>
              <Box className="jd-additional-skills-section drawer-field">
                <Typography variant="h6" className="jd-upload-expiry-title">
                  Skills
                </Typography>
                <Typography variant="body2" className="jd-section-subtitle" sx={{ mb: 2 }}>
                  Add skills required for this position. Mark exactly one as primary. Total weightage: {totalWeightage} / {MAX_TOTAL_WEIGHTAGE}
                </Typography>

                <Table className="jd-additional-skills-table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Skill Name*</TableCell>
                      <TableCell>Proficiency Level*</TableCell>
                      <TableCell>Weightage*</TableCell>
                      <TableCell>Primary</TableCell>
                      <TableCell>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {skills.map((skill, index) => (
                      <TableRow key={index} className="jd-skill-row">
                        <TableCell>
                          <Autocomplete
                            freeSolo
                            options={skillOptions}
                            value={skill.skill}
                            onChange={(event, newValue) => {
                              handleSkillChange(newValue || '', index, 'skill');
                            }}
                            onInputChange={(event, newInputValue) => {
                              handleSkillChange(newInputValue, index, 'skill');
                            }}
                            disabled={isSaving}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select or type a skill"
                                size="small"
                                fullWidth
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell>
                          <Autocomplete
                            options={SKILL_DIFFICULTY_OPTIONS}
                            value={skill.difficultyLevel}
                            onChange={(event, newValue) => {
                              handleSkillChange(newValue, index, 'difficultyLevel');
                            }}
                            disabled={isSaving}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select level"
                                size="small"
                                fullWidth
                              />
                            )}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            type="number"
                            size="small"
                            fullWidth
                            placeholder="Weightage"
                            value={skill.weightage}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (val === '') {
                                handleWeightageChange('', index);
                                return;
                              }

                              const numVal = Number(val);
                              if (numVal >= 0 && numVal <= MAX_TOTAL_WEIGHTAGE) {
                                handleWeightageChange(numVal, index);
                              }
                            }}
                            onBlur={(e) => {
                              const val = e.target.value;
                              if (val === '') return;

                              const otherTotal = getTotalWeightage(skills, index);
                              const maxAllowed = MAX_TOTAL_WEIGHTAGE - otherTotal;
                              let numVal = Number(val);
                              numVal = Math.max(0, Math.min(MAX_TOTAL_WEIGHTAGE, maxAllowed, numVal));
                              handleSkillChange(numVal, index, 'weightage');
                            }}
                            disabled={isSaving}
                            slotProps={{
                              htmlInput: {
                                min: 0,
                                max: MAX_TOTAL_WEIGHTAGE,
                                onKeyDown: (e) => {
                                  if (['e', 'E', '+', '-', '.'].includes(e.key)) {
                                    e.preventDefault();
                                  }
                                },
                              },
                            }}
                            error={
                              skill.weightage !== '' &&
                              (Number(skill.weightage) < 0 ||
                            Number(skill.weightage) > MAX_TOTAL_WEIGHTAGE ||
                            totalWeightage > MAX_TOTAL_WEIGHTAGE)
                            }
                            helperText={
                              skill.weightage !== '' &&
                              (Number(skill.weightage) < 0 || Number(skill.weightage) > MAX_TOTAL_WEIGHTAGE)
                                ? `Value must be between 0 and ${MAX_TOTAL_WEIGHTAGE}`
                                : totalWeightage > MAX_TOTAL_WEIGHTAGE
                                  ? `Total weightage cannot exceed ${MAX_TOTAL_WEIGHTAGE}`
                                  : ''
                            }
                          />
                        </TableCell>
                        <TableCell className="jd-skill-primary-cell">
                          <Switch
                            checked={Boolean(skill.isPrimary)}
                            onChange={(e) => handlePrimaryToggle(index, e.target.checked)}
                            disabled={isSaving}
                            color="primary"
                            size="small"
                          />
                        </TableCell>
                        <TableCell className="jd-skill-action-cell">
                          <button
                            type="button"
                            className="jd-remove-skill-btn"
                            onClick={() => removeSkill(index)}
                            disabled={skills.length <= 1 || isSaving}
                            aria-label="Remove skill"
                          >
                            <Cancel />
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                    <TableRow className="jd-add-skill-row">
                      <TableCell colSpan={5}>
                        <button
                          type="button"
                          className="jd-add-skill-btn"
                          onClick={addSkill}
                          disabled={isSaving || skills.length >= MAX_SKILLS}
                        >
                          <AddCircle className="jd-add-skill-btn-icon" />
                          <span>Add Skill</span>
                        </button>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </Box>
              <div className="drawer-field">
                <label className="drawer-label">Difficulty Level</label>
                <TextField
                  fullWidth
                  value={editFormData.difficultyLevel}
                  onChange={(e) => handleFormChange('jobTitle', e.target.value)}
                  variant="outlined"
                  disabled
                />
              </div>
              <div className="drawer-field">
                <label className="drawer-label">Assessment Duration (seconds)</label>
                <TextField
                  fullWidth
                  value={editFormData.assessmentDurationInSeconds}
                  onChange={(e) => handleFormChange('jobTitle', e.target.value)}
                  variant="outlined"
                  disabled
                />
              </div>
              <div className="drawer-field">
                <label className="drawer-label">Is Active</label>
                <FormControl fullWidth variant="outlined" disabled={isSaving}>
                  <Select
                    id="is-active-select"
                    value={editFormData.isActive}
                    onChange={(e) => handleFormChange('isActive', e.target.value)}
                  >
                    <MenuItem value={true}>True</MenuItem>
                    <MenuItem value={false}>False</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="drawer-field">
                <label className="drawer-label">Expiry Date</label>
                <div className="date-picker-filter-container">
                  <DatePicker
                    selected={editFormData.expiryAt}
                    onChange={(date) => handleFormChange('expiryAt', date)}
                    dateFormat="MM/dd/yyyy"
                    placeholderText="Select expiry date"
                    isClearable
                    showIcon={false}
                    disabled={isSaving}
                    minDate={DateTime.now().plus({ days: 1 }).toJSDate()}
                    className="date-picker-table-filter"
                  />
                </div>
              </div>
              <div className="drawer-field-readonly">
                <label className="drawer-label">Created By</label>
                <TextField
                  fullWidth
                  value={selectedRow.createdBy || 'N/A'}
                  variant="outlined"
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled
                />
              </div>
              <div className="drawer-field-readonly">
                <label className="drawer-label">Created At</label>
                <TextField
                  fullWidth
                  value={selectedRow.createdAt || 'N/A'}
                  variant="outlined"
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled
                />
              </div>
              <div className="drawer-field-readonly">
                <label className="drawer-label">Updated At</label>
                <TextField
                  fullWidth
                  value={selectedRow.updatedAt || 'N/A'}
                  variant="outlined"
                  InputProps={{
                    readOnly: true,
                  }}
                  disabled
                />
              </div>
              {selectedRow.id && (
                <div className="drawer-field">
                  <label className="drawer-label">ID</label>
                  <TextField
                    fullWidth
                    value={selectedRow.id}
                    variant="outlined"
                    InputProps={{
                      readOnly: true,
                    }}
                    disabled
                  />
                </div>
              )}
              <div className="drawer-actions">
                <Button
                  variant="outlined"
                  onClick={handleCloseDrawer}
                  disabled={isSaving}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleSaveChanges}
                  disabled={isSaving}
                  startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : null}
                >
                  {isSaving ? 'Saving...' : 'Save Changes'}
                </Button>
              </div>
            </div>
          )}
        </div>
      </Drawer>
    </div>
  );
};

export default ManageJd;
